import React from 'react';
import { Button, ButtonWrap, Input } from './NumberOfGuests.styled';
import { Add, Remove } from 'components/svg';
import { OccupancyProps } from './OccupancySelector.types';

const OccupancySelector: React.FC<OccupancyProps> = ({group, handleOccupancy, count, disabledButton})  => {
    return (
        <ButtonWrap
        key={`counter-${group}-guests`}
        >
        <Button
          id={`${group}-decrement`}
          onClick={() => handleOccupancy(group, count - 1)}
          disabled={disabledButton.decrement}
          >
          <Remove />
        </Button>
        <Input 
            className={`number-of-guests-${group}`}  value={count}
            />
        <Button
          id={`${group}-increment`}
          onClick={() => handleOccupancy(group, count + 1)}
          disabled={disabledButton.increment}
          >
          <Add />
        </Button>
      </ButtonWrap>
    );
};

export default OccupancySelector;